import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { analyticsApi } from '@/services/apis/analytics';

export const analyticsKeys = {
  all: ['analytics'] as const,
  summary: () => [...analyticsKeys.all, 'summary'] as const,
};

export const useAnalyticsSummary = () => {
  return useQuery({
    queryKey: analyticsKeys.summary(),
    queryFn: async () => {
      const response = await analyticsApi.getSummary();
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes (matches backend cache)
    refetchOnWindowFocus: false,
  });
};

export const useInvalidateAnalyticsCache = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await analyticsApi.invalidateCache();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: analyticsKeys.summary() });
    },
  });
};
